// =============================================================================
// Origin UI — src/components/AppLayout.tsx
// Main application layout with sidebar navigation and content area.
// Wraps all authenticated pages.
// =============================================================================

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { HelpChatWidget } from './HelpChatWidget';
import styles from './AppLayout.module.css';

/**
 * Top-level layout component providing the sidebar and main content area.
 * Uses React Router's <Outlet /> to render child route components.
 */
export function AppLayout() {
  return (
    <div className={styles.layout}>
      <Sidebar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <HelpChatWidget />
    </div>
  );
}
